// extracted by mini-css-extract-plugin
export default {"dataDisplay":"SurveysPage_dataDisplay__yP6or","value":"SurveysPage_value__3nyT1","subText":"SurveysPage_subText__erPb-"};